<template>
  <c-selectable
    v-bind="$attrs"
    @click.stop
  />
</template>

<script>
import CSelectable from '@convenia/components/CSelectable'

export default {
  name: 'MobileSelectable',
  components: { CSelectable },
}
</script>
